import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=6127009a&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style0 from "./Contact.vue?vue&type=style&index=0&id=6127009a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6127009a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TeamMember: require('/home/rohit/Documents/GitHub/aibuddha-website/components/TeamMember.vue').default})
